import React, { useState } from 'react';
import Modal from '../../common/Modal';
import SaveCancelButtons from '../../common/buttons/SaveCancelButtons';
import Label from '../../common/Label';
import { styled } from 'styled-components';
import { archiveProject } from '../../../services/project-service';
import {
	Project,
	projectArchiveReasonOptions,
} from '../../../data/models/project';
import ModalHeader from '../../common/ModalHeader';
import Dialog, {
	DialogActions,
	DialogContent,
	DialogTitle,
} from '../../common/Dialog';
import Button from '../../common/buttons/Button';
import { useDispatch } from 'react-redux';
import {
	asyncCallDone,
	asyncCallStart,
	refreshProjectSuccess,
} from '../../../data/stores/projectStore';
import { showAlert } from '../../../data/stores/alertStore';
import Select from '../../common/form/Select';

interface ProjectArchiveModalProps {
	open: boolean;
	handleClose: () => void;
	project: Project;
}
export default function ProjectArchiveModal(props: ProjectArchiveModalProps) {
	const { open, handleClose, project } = props;

	const dispatch = useDispatch();
	const [conformationModalOpen, setConformationModalOpen] = useState(false);
	const [archivedReason, setArchivedReason] = useState('');

	const onClose = () => {
		setArchivedReason('');
		handleClose();
	};

	const handleArchive = async () => {
		try {
			onClose();
			setConformationModalOpen(false);
			dispatch(asyncCallStart());
			const updatedProject = await archiveProject(
				project.id,
				archivedReason
			);
			dispatch(refreshProjectSuccess(updatedProject));
			dispatch(
				showAlert({
					message: 'Successfully archived the project.',
					severity: 'success',
				})
			);
		} catch (error) {
			dispatch(
				showAlert({
					message: 'An error occurred archiving the project.',
					severity: 'error',
				})
			);
		} finally {
			dispatch(asyncCallDone());
		}
	};

	const getReasonDisplay = (reason: string) => {
		return projectArchiveReasonOptions().find((r) => r.id === reason)
			?.display;
	};

	return (
		<Modal open={open} handleClose={onClose}>
			<ModalHeader>Archive Project</ModalHeader>
			<Label>Name</Label>
			<Info>{project.namespace}</Info>
			<Label>Client</Label>
			<Info>{project.client.name}</Info>
			<ArchiveReasonSelect
				label={'Reason'}
				options={projectArchiveReasonOptions()}
				value={archivedReason}
				onChange={(e) => setArchivedReason(e.target.value)}
			/>
			<SaveCancelContainer>
				<SaveCancelButtons
					handleSave={() => setConformationModalOpen(true)}
					handleCancel={onClose}
					saveText={'Archive'}
				/>
			</SaveCancelContainer>
			<Dialog
				open={conformationModalOpen}
				handleClose={() => setConformationModalOpen(false)}
			>
				<DialogTitle>Confirm Project Archive</DialogTitle>
				<DialogContent>
					<Label>Name</Label>
					<Info>{project.namespace}</Info>
					<Label>Client</Label>
					<Info>{project.client.name}</Info>
					<Label>Reason</Label>
					<Info>{getReasonDisplay(archivedReason)}</Info>
					<ConfirmationText>
						Are you sure you want to achive this project?
					</ConfirmationText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setConformationModalOpen(false)}
						variant={'text'}
					>
						Cancel
					</Button>
					<Button onClick={handleArchive}>Confirm</Button>
				</DialogActions>
			</Dialog>
		</Modal>
	);
}

const Info = styled.div`
	margin-bottom: ${(props) => props.theme.spacing(1)};
`;

const SaveCancelContainer = styled.div`
	margin-top: ${(props) => props.theme.spacing(4)};
`;

const ArchiveReasonSelect = styled(Select)`
	margin-top: ${(props) => props.theme.spacing(3)};
`;

const ConfirmationText = styled.div`
	margin-top: ${(props) => props.theme.spacing(3)};
`;
